<template>
  <page>
    <div class="bg-color invoice-page">
      <div class="invoice-title">
        <van-cell-group>
          <van-cell title="发票类型" value="电子普通发票" />
        </van-cell-group>
      </div>
      <div class="invoice-choice">
        <van-cell-group class="nvoice-cell">
          <div class="field">
            <van-cell class="field-label"  title="发票抬头"/>
            <div class="field-value">
              <van-button class="button" :class="[invoiceMsg.type === 0 ? 'cur' : '']" slot="button" size="small" @click="changeBtn(0)">个人</van-button>
              <van-button  class="button" :class="[invoiceMsg.type === 1 ? 'cur' : '']" slot="button" size="small" @click="changeBtn(1)">单位</van-button>
            </div>
          </div>
          <div v-if="invoiceMsg.type === 0">
            <van-field v-model="invoiceMsg.invContent" placeholder="请输入个人姓名" />
          </div>
          <div v-else>
            <van-field v-model="invoiceMsg.invContent" placeholder="请输入单位名称"/>
            <van-field v-model="invoiceMsg.taxpayerNumber" placeholder="纳税人识别号或统一社会信用代码" />
          </div>
        </van-cell-group>
        <van-cell-group>
          <van-field
            v-model="invoiceMsg.invMessage"
            clearable
            required
            label="发票内容"
            placeholder="请输入发票内容"
            @click-right-icon="$toast('发票内容必填')"
          />
          <van-field
            v-model="invoiceMsg.goodsPrice"
            clearable
            required
            label="发票金额"
            placeholder="请输入发票金额"
            @click-right-icon="$toast('用户名必须是手机号')"
          />
          <van-field
            v-model="invoiceMsg.mobile"
            clearable
            required
            label="收件人手机号"
            placeholder="请输入收票人手机号"
            @click-right-icon="$toast('用户名必须是手机号')"
          />
          <van-field
            v-model="invoiceMsg.invContent"
            clearable
            label="收票人邮箱"
            placeholder="请输入售票人邮箱"
            @click-right-icon="$toast('用户名必须是手机号')"
          />
          <div class="md15">
            <van-button type="danger" size="large" @click="submitOrder" class="submit-btn">提交</van-button>
          </div>
        </van-cell-group>
      </div>
    </div>
  </page>
</template>
<script>
export default {
  data () {
    return {
      invoiceMsg: {
        type: 0, // 0 代表个人，1代表单位
        invPayee: '个人',
        invCom: '单位',
        invContent: '',
        invMessage: '',
        mobile: '',
        goodsPrice: '',
        taxpayerNumber: '' // 纳税人识别号
      }
    }
  },
  methods: {
    submitOrder () {
      let parmas = {}
      parmas = this.invoiceMsg
      if (this.invoiceMsg.invMessage === '') {
        this.$toast('发票内容不能为空')
        return false
      }
      if (this.invoiceMsg.mobile === '') {
        this.$toast('收件人手机号不能为空')
        return false
      }
      if (this.invoiceMsg.goodsPrice === '') {
        this.$toast('发票金额不能为空')
        return false
      }
      this.$router.push({ name: 'paying', query: parmas })
    },
    changeBtn (type) {
      if (type === 0) {
        this.invoiceMsg.type = 0
        // console.log(type, '------')
      } else {
        this.invoiceMsg.type = 1
        // console.log(type, '------')
      }
    }
  }
}
</script>
<style lang="stylus" scoped>
.invoice-page
  height 100vh
.invoice-choice
  background #fff
.field
 height 43px
 line-height 28px
 border-bottom 1px solid #ebedf0
.field .field-label
  width 30%
  float left
  border-bottom none
.field .field-value
  width 55%
  float left
  padding-top 5px
.field-value .button
  color #333
  margin 0 5px
.field-value .button.cur
  border-color #FC4C00
  color #FC4C00
.md15
 margin 15px
</style>
